// extracted by mini-css-extract-plugin
export default {"title_header":"TitleHeader_title_header__RLNRt","title_text":"TitleHeader_title_text__I5Hj2"};